import { createStore, compose, applyMiddleware } from 'redux';
import { syncHistoryWithStore } from 'react-router-redux';
import { browserHistory } from 'react-router';

//import the root reducer
import rootReducer from './reducers/index';

//middleware, promises and logger
import logger from "redux-logger";
import thunk from "redux-thunk";
import promise from "redux-promise-middleware";

//create an Object for default data

const enhancers = compose(
  window.devToolsExtension ? window.devToolsExtension() : f => f
);
let middleware = null;
if (process.env.NODE_ENV === 'development') {
  middleware = applyMiddleware(promise(), thunk, logger());
} else {
  middleware = applyMiddleware(promise(), thunk);
}
const store = createStore(rootReducer, enhancers, middleware);
export const history = syncHistoryWithStore(browserHistory, store);

if (module.hot) {
  module.hot.accept('./reducers/', () => {
    const nextRootReducer = require('./reducers/index').default;
    store.replaceReducer(nextRootReducer);
  })
}

export default store;



/** WEBPACK FOOTER **
 ** ./src/store.js
 **/